var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.827,
    height: 12.582,
    viewBox: "0 0 6.827 12.582",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7629",
    "data-name": "Pfad 7629",
    d: "M0,4.755,5.647,0l5.647,4.755",
    transform: "translate(5.52 0.644) rotate(90)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Arrow_Icon.67dc786f4e3869444c8adbfc693e3fed.svg";